import get from 'lodash.get'
import { useEffect, useState } from 'react'
import { UseFormReturn } from 'react-hook-form'

export default function useFormState(
  attribute: string,
  formMethods: UseFormReturn | null,
  isArray = false,
) {
  const [value, setValue] = useState<any>()

  useEffect(() => {
    const initialVal = formMethods?.getValues(attribute)
    setValue(initialVal)
    formMethods?.watch((value, { name }) => {
      if (
        name === attribute ||
        (isArray && name?.startsWith(attribute + '.'))
      ) {
        const fieldValue = get(value, attribute)
        setValue(isArray ? [...(fieldValue || [])] : fieldValue)
      }
    })
  }, [attribute, formMethods])

  return value
}
